import { Input } from '@remote-medium/ui';
import type { ComponentProps, ReactNode } from 'react';

// One numeric setting: label (and hint) on the left, a short right-aligned
// input with its unit on the right, the validation message underneath.
export function NumberRow({
  id,
  label,
  hint,
  unit,
  error,
  ...input
}: Omit<ComponentProps<'input'>, 'size'> & {
  id: string;
  label: ReactNode;
  hint?: ReactNode;
  unit: string;
  error?: string | undefined;
}) {
  return (
    <div className="flex flex-col gap-1 border-t border-border py-3 first:border-t-0 first:pt-0">
      <div className="flex items-center justify-between gap-4">
        <label htmlFor={id} className="flex min-w-0 flex-col gap-0.5">
          <span className="text-sm font-medium">{label}</span>
          {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
        </label>
        <div className="flex shrink-0 items-center gap-2">
          <Input
            id={id}
            type="text"
            inputMode="numeric"
            aria-invalid={!!error}
            className="w-16 text-right tabular-nums"
            {...input}
          />
          <span className="w-8 text-xs text-muted-foreground">{unit}</span>
        </div>
      </div>
      {error && <p className="m-0 text-right text-xs text-destructive">{error}</p>}
    </div>
  );
}
